<template>
  <div class="pretrain-operate dataset-create">
    <div class="pretrain-header header">
      <h3 class="title">创建数据集</h3>
    </div>
    <div class="main">
      <!-- 创建数据集 create  -->
      <div class="create">
        <div class="intxt intxt-bottom">
          <label class="label" for="">
            <i class="required">*</i>数据集名称：
          </label>
          <el-input
            class="input"
            placeholder="请输入数据集名称"
            v-model.trim="Dataset.name"
            maxlength="20"
            show-word-limit
          />
        </div>
        <div class="intxt">
          <label class="label" for="">
            <i class="required">*</i>数据集描述：
          </label>
          <el-input
            type="textarea"
            :rows="6"
            maxlength="200"
            show-word-limit
            placeholder="请输入数据集描述"
            v-model.trim="Dataset.content"
          />
        </div>
        <div class="btns">
          <el-button type="primary" class="btn-primary" @click="createDataset">
            确定
          </el-button>
          <el-button
            type="info"
            class="btn-cancel"
            @click="createDatasetCancel"
          >
            取消
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PRETRAIN from "@/axios/pretrain/pretrain.js";
export default {
  data() {
    return {
      Dataset: {
        name: "",
        content: ""
      },
      errorCount: 0
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    modelType() {
      return this.$route.params.modeltype;
    }
  },
  watch: {
    token() {
      this.createDataset();
    }
  },
  mounted() {},
  methods: {
    /**
     * 创建数据集  @data datasetContent数据集简介 datasetName数据集名称  type数据集类型
     */
    createDataset() {
      var datasetName = this.Dataset.name,
        datasetContent = this.Dataset.content,
        modeltype = this.modelType,
        data = {};

      if (!datasetName || !datasetContent) {
        // TODO: 必填项未填写提示，后期可以进一步优化
        return this.$message.error("请将数据相关信息填写完整");
      }

      // TODO:数据集描述还需要处理
      data = Object.assign(data, {
        datasetName: datasetName,
        type: modeltype,
        datasetContent: datasetContent
      });

      PRETRAIN.addDataset(data).then(result => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg);
          this.$router.push({
            name: "dataset-list",
            params: { modeltype: modeltype }
          });
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    createDatasetCancel() {
      this.$router.push({
        name: "dataset-list",
        params: { modeltype: this.modelType }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./pretrain_common.scss";
</style>
